import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-update",
  "use": "icon-update-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-update\"><path d=\"M24.797 11.24A9.96 9.96 0 0 1 26 16c0 5.523-4.477 10-10 10-.68 0-1.345-.068-1.987-.197L13.8 25.8l2.4 2.2-1.4 1.4-4.8-4.6 4.6-4.8 1.6 1.6-2.157 2.159q.09.023.181.043l.176-.002v.04a8 8 0 0 0 8.905-11.108zM17.6 2.4l4.6 4.8-4.8 4.6-1.4-1.4 2.264-2.075a8 8 0 0 0-9.69 10.654l-1.512 1.51A9.96 9.96 0 0 1 6 16c0-5.523 4.477-10 10-10q1.027.002 1.996.2h.204L16 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol